// extracted by mini-css-extract-plugin
export default {"base":"vp_nELBx","frame":"vp_HaC1v","table":"vp_zGPbP","wrapper":"vp_hTVX4"};